const CHANNEL_OPTIONS = ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"];

const TENANT_NOTIFICATION_TYPE_OPTIONS = [
  {
    value: "BEFORE_DUE",
    label: "Before due date",
    description: "Send exactly N days before the due date.",
  },
  {
    value: "ON_DUE",
    label: "On due date",
    description: "Send on the due date day (offset usually 0).",
  },
  {
    value: "AFTER_DUE",
    label: "After due date",
    description: "Send exactly N days after the due date.",
  },
  {
    value: "OVERDUE_AT_LEAST_N_DAYS",
    label: "Overdue at least N days",
    description: "Send when overdue days are greater than or equal to N.",
  },
  {
    value: "OVERDUE_BETWEEN_N_AND_M_DAYS",
    label: "Overdue between N and M days",
    description: "Send when overdue days are within range N to M.",
  },
  {
    value: "DUE_IN_AT_MOST_N_DAYS",
    label: "Due in at most N days",
    description: "Send when due date is less than or equal to N days away.",
  },
  {
    value: "DUE_BETWEEN_N_AND_M_DAYS",
    label: "Due between N and M days",
    description: "Send when due date is within range N to M days away.",
  },
];

const TENANT_SCOPE_OPTIONS = ["ALL_TENANCIES"];

const PAYOUT_NOTIFICATION_TYPE_OPTIONS = [
  {
    value: "BEFORE_PAYDAY",
    label: "Before payday",
    description: "Send exactly N days before payday.",
  },
  {
    value: "ON_PAYDAY",
    label: "On payday",
    description: "Send on payday day (offset usually 0).",
  },
  {
    value: "AFTER_PAYDAY",
    label: "After payday",
    description: "Send exactly N days after payday.",
  },
];

const DISPATCH_STATUS_OPTIONS = ["PENDING", "SENT", "FAILED", "SKIPPED"];

const DELIVERY_MODE_OPTIONS = ["TEXT", "DOCUMENT"];

const BROADCAST_AUDIENCE_OPTIONS = ["TENANTS", "LANDLORDS"];

/** Instant (event-driven) templates — scheduled rules must not use these. */
const EVENT_KEY_OPTIONS = [
  {
    value: "landlord_tenant_self_onboard",
    label: "Landlord: tenant self-onboard",
    description: "When a tenant self-onboards and matches a registered landlord.",
    delivery_mode: "TEXT",
    channels: ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"],
    template_type: "LANDLORD_TENANT_SELF_ONBOARD",
  },
  {
    value: "tenant_payment_receipt",
    label: "Tenant: payment receipt",
    description: "Payment confirmed (assign flow / QueryPaymentProgress).",
    delivery_mode: "DOCUMENT",
    channels: ["WHATSAPP", "EMAIL"],
    template_type: "TENANT_PAYMENT_RECEIPT",
  },
  {
    value: "tenant_broadcast",
    label: "Tenant broadcast",
    description: "Admin broadcast job with audience TENANTS.",
    delivery_mode: "TEXT",
    channels: ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"],
    template_type: "TENANT_BROADCAST",
  },
  {
    value: "landlord_broadcast",
    label: "Landlord broadcast",
    description: "Admin broadcast job with audience LANDLORDS.",
    delivery_mode: "TEXT",
    channels: ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"],
    template_type: "LANDLORD_BROADCAST",
  },
];

const EVENT_KEY_TO_TEMPLATE_TYPE = EVENT_KEY_OPTIONS.reduce((accumulator, option) => {
  accumulator[option.value] = option.template_type;
  return accumulator;
}, {});

const isScheduledTemplate = (template) => !template?.event_key;

const channelsForEventKey = (eventKey) => {
  const match = EVENT_KEY_OPTIONS.find((option) => option.value === eventKey);
  return match?.channels ?? CHANNEL_OPTIONS;
};

const deliveryModeForEventKey = (eventKey) => {
  const match = EVENT_KEY_OPTIONS.find((option) => option.value === eventKey);
  return match?.delivery_mode ?? "TEXT";
};

export {
  CHANNEL_OPTIONS,
  TENANT_NOTIFICATION_TYPE_OPTIONS,
  TENANT_SCOPE_OPTIONS,
  PAYOUT_NOTIFICATION_TYPE_OPTIONS,
  DISPATCH_STATUS_OPTIONS,
  DELIVERY_MODE_OPTIONS,
  BROADCAST_AUDIENCE_OPTIONS,
  EVENT_KEY_OPTIONS,
  EVENT_KEY_TO_TEMPLATE_TYPE,
  isScheduledTemplate,
  channelsForEventKey,
  deliveryModeForEventKey,
};
